import "./GithubHighlights.css";

import React from "react";
import content from "../../generated/content.json";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const pickDescription = (description, lang) => {
  if (!description) return null;
  if (typeof description === "string") return description;
  return description[lang] || description.en || null;
};

const GithubHighlights = () => {
  const t = useT();
  const { lang } = useLocale();
  const items = content.githubHighlights || [];
  if (items.length === 0) return null;
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="github-highlights">
      <h1 className="text-uppercase mb-4">{t("sections.github.title")}</h1>
      <div className="row g-3">
        {items.map((item) => {
          const description = pickDescription(item.description, lang);
          return (
            <div className="col-sm-6 col-lg-4" key={item.url}>
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="github-card"
              >
                <div className="github-card-icon">
                  <i className="fa fa-github" aria-hidden="true"></i>
                </div>
                <div className="github-card-body">
                  <div className="github-card-name">{item.name}</div>
                  {description && (
                    <div className="github-card-description">{description}</div>
                  )}
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default GithubHighlights;
